import React from "react";
import style from "./auth.module.css";
import { Helmet } from "react-helmet-async";
import FlipBook from "../../components/FlipBook/FlipBook";

const CenterSucess = () => {
  return (
    <>
      <Helmet>
        <title>Thank-you - Fund Life</title>
      </Helmet>
      <div style={{ paddingTop: "80px" }}>
        <img className="w-100" src="/newmike.png" alt="banner" style={{ height: "auto", display: "block" }} />

        <div className="container mt-4">
          {/* Interactive Flipbook Player */}
          <div className="my-5">
            <FlipBook pdfUrl="/Love_Smarter_Not_Harder_Final.pdf" />
          </div>

          <div className={style.CenterSucesscontainer}>
            <p>
              Hi, as the founder and president of Fund Life,
              I want to personally thank you for joining our crowdfunding platform.
              I want you to know that we are fully committed to supporting the
              incredible work you’re doing on behalf of our cause. We believe that
              the essential services and advocacy you provide are invaluable in
              promoting and protecting the sanctity of life. Also, if you encounter
              an urgent mission-related need, please contact us. As a member of our
              family, we will use whatever connections are available to us to help
              you meet those needs.
            </p>

            <p>
              By joining our community, we offer a unique opportunity to connect
              with a wider audience who share a passion for this important mission
              you’re carrying out on behalf of our Lord. And we are truly honored to
              be a part of helping amplify the impact you are making every day.
              Together, we will rally more support and resources to ensure every
              life is valued and protected.
            </p>

            <p>
              We are excited about supporting the amazing work you do for the pro-life cause.
            </p>

            <p>
              Thank you for your continued dedication to this vital mission.
            </p>

            <h2 className="text-center mt-5 mb-5 fw-bold" style={{ fontSize: "1.4rem", color: "#3b304f", lineHeight: "1.6" }}>
              Please check your email for login details. If you do not see the email in your inbox, please check your spam folder.
            </h2>
          </div>
        </div>
      </div>
    </>
  );
};

export default CenterSucess;
